import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    // [] significa que aun no se consultaron los accesos: mientras tanto el
    // sistema se comporta como permisivo (igual que antes de la seguridad).
    accesos: [],
    seguridadActiva: "N",
    exigeCredenciales: "N",
    // Token de autorizacion de una accion sensible (dura tres minutos).
    token: "",
    usuarioToken: "",
    expiraToken: "",
}

export const seguridadSlice = createSlice({
    name: "seguridad",
    initialState,
    reducers: {
        setAccesos: (state, action) => {
            state.accesos = action.payload || [];
        },
        setParametros: (state, action) => {
            const parametros = action.payload || {};

            state.seguridadActiva = parametros.SEGURIDAD_ACTIVA || "N";
            state.exigeCredenciales = parametros.SEGURIDAD_EXIGE_CREDENCIALES || "N";
        },
        setToken: (state, action) => {
            const data = action.payload || {};

            state.token = data.token || "";
            state.usuarioToken = data.usuario || "";
            state.expiraToken = data.expira || "";
        },
        limpiarToken: (state) => {
            state.token = "";
            state.usuarioToken = "";
            state.expiraToken = "";
        },
    },
});

export const { setAccesos, setParametros, setToken, limpiarToken } = seguridadSlice.actions;
export default seguridadSlice.reducer;